import React from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import moment from 'moment-jalaali'

// const minuteSeconds = 60;
// const hourSeconds = 3600;
// const daySeconds = 86400;

const timerProps = {
  isPlaying: true,
  // size: 100,
  // strokeWidth: 5
};

const renderTime = (dimension, time) => {
  return (
    <div className="time-wrapper">
      <div className="time">{time}</div>
      <div>{dimension}</div>
    </div>
  );
};

export default function CountDown({ remainingSeconds }) {

  return (
    <div className="ltr">
      <CountdownCircleTimer
        {...timerProps}
        colors={[['#10B516', 0.33], ['#F7931A', 0.33], ['#FF231F']]}
        trailColor={'#e1e1e1'}
        strokeLinecap="square"
        duration={remainingSeconds}
      >
        {({ elapsedTime, remainingTime }) =>
          renderTime("زمان باقیمانده", convertToTime(remainingTime * 1000))
        }
      </CountdownCircleTimer>
    </div>
  );
}

function convertToTime(duration) {
  let remain = Number(duration)

  // let days = Math.floor(remain / (1000 * 60 * 60 * 24))
  // remain = remain % (1000 * 60 * 60 * 24)

  let hours = Math.floor(remain / (1000 * 60 * 60))
  remain = remain % (1000 * 60 * 60)

  let minutes = Math.floor(remain / (1000 * 60))
  remain = remain % (1000 * 60)

  let seconds = Math.floor(remain / (1000))
  remain = remain % (1000)

  var res = hours > 0 ? `${(`${hours}:${minutes}:${seconds}`)}` : (minutes > 0 ? `${(`${minutes}:${seconds}`)}` : `${(`${seconds}`)}`)
  return hours > 0 ? moment(res, "HH:mm:ss").format("HH:mm':ss''") : (minutes > 0 ? moment(res, "mm:ss").format("mm':ss''") : moment(res, "ss").format("ss''"))
}
